import { useContext } from "react";
import { LeaderboardContext } from "../context/context";

export const useLeaderboard = () => useContext(LeaderboardContext);
